import { CONTRACTOR_TYPES } from "@/static/contractorTypes";
import { Expose } from "class-transformer";
import { IsEnum, IsOptional, IsString } from "class-validator";

export class OrderMonit {
  @IsOptional()
  @IsString()
  @Expose()
  title!: null | string;
  @IsOptional()
  @IsString()
  @Expose()
  content!: null | string;
}

export class ContractorMonit {
  @IsOptional()
  @IsString()
  @Expose()
  title!: null | string;
  @IsOptional()
  @IsString()
  @Expose()
  content!: null | string;
  @Expose()
  @IsEnum(CONTRACTOR_TYPES)
  type!: CONTRACTOR_TYPES;
}
